module.exports = __webpack_public_path__ + "img/营销伙伴08.58bf8544.png";